import {Samples} from "src/app/infrastructure/moovement-api/models/samples";

export function isValidGpsFixSample(assetSample: Samples.AssetSample<Samples.GPSFix>) {
  const lat = assetSample.sample?.value?.position?.coords?.[0]
  const lng = assetSample.sample?.value?.position?.coords?.[1]
  return lat != undefined && lat != 0 && lng != undefined && lng != 0
}

export function isValidNfcGpsFixSample(assetSample: Samples.AssetSample<Samples.NfcGpsFix>) {
  const lat = assetSample.sample?.value?.position?.coords?.[0]
  const lng = assetSample.sample?.value?.position?.coords?.[1]
  return lat != undefined && lat != 0 && lng != undefined && lng != 0
}
